export default "__VITE_ASSET__2f95ec2b__"